(async function () {
  const root = document.querySelector("[data-store-locator]");
  if (!root) return;

  const storesUrl = root.getAttribute("data-stores-url");
  const $ = (sel) => root.querySelector(sel);

  const deptSelect = $(".sl-dept");
  const citySelect = $(".sl-city");
  const typeSelect = $(".sl-type");
  const searchInput = $(".sl-search");
  const nearBtn = $(".sl-near");
  const results = $(".sl-results");
  const statusEl = $(".sl-status");

  const setStatus = (msg = "") => {
    if (statusEl) statusEl.textContent = msg;
  };

  // ---------------------------
  // NORMALIZACIÓN
  // ---------------------------
  const cleanStr = (v) => {
    let t = (v ?? "").toString().trim().replace(/\s+/g, " ");
    if (t.toLowerCase() === "nan") return "";
    return t;
  };

  const keyStr = (v) =>
    cleanStr(v)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase();

  const normSearch = (v) => keyStr(v).toLowerCase();

  const escapeHtml = (v) =>
    cleanStr(v).replace(/[&<>"']/g, (c) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[c]));

  // ---------------------------
  // FETCH STORES
  // ---------------------------
  let stores = [];
  try {
    setStatus("Cargando puntos...");
    const res = await fetch(storesUrl, { cache: "no-store" });
    if (!res.ok) throw new Error("No se pudo cargar stores.json");
    stores = await res.json();
  } catch (e) {
    setStatus("");
    results.innerHTML = `<div class="sl-card"><b>Error:</b> No se pudo cargar la data de tiendas.</div>`;
    return;
  } finally {
    setStatus("");
  }

  // Solo lat/lng válidos + preprocesamiento
  stores = stores
    .filter((s) => Number.isFinite(+s.lat) && Number.isFinite(+s.lng))
    .map((s) => {
      const department = cleanStr(s.department);
      const city = cleanStr(s.city);
      const type = cleanStr(s.type);

      return {
        ...s,
        department,
        city,
        type,
        name: cleanStr(s.name),
        address: cleanStr(s.address),
        neighborhood: cleanStr(s.neighborhood),
        whatsapp: cleanStr(s.whatsapp),
        phone: cleanStr(s.phone),
        hours: cleanStr(s.hours),
        _depKey: keyStr(department),
        _cityKey: keyStr(city),
        _typeKey: keyStr(type),
      };
    });

  // ---------------------------
  // LEAFLET LOAD
  // ---------------------------
  const loadCss = (href) =>
    new Promise((ok) => {
      const l = document.createElement("link");
      l.rel = "stylesheet";
      l.href = href;
      l.onload = ok;
      document.head.appendChild(l);
    });

  const loadJs = (src) =>
    new Promise((ok) => {
      const s = document.createElement("script");
      s.src = src;
      s.onload = ok;
      document.head.appendChild(s);
    });

  await loadCss("https://unpkg.com/leaflet@1.9.4/dist/leaflet.css");
  await loadJs("https://unpkg.com/leaflet@1.9.4/dist/leaflet.js");

  const mapEl = $(".sl-map");
  const map = L.map(mapEl, { scrollWheelZoom: false }).setView([4.7, -74.1], 6);
  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
    attribution: "&copy; OpenStreetMap",
  }).addTo(map);
  const markersLayer = L.layerGroup().addTo(map);

  // ---------------------------
  // SELECTS
  // ---------------------------
  function uniqOptions(items, keyFn, labelFn) {
    const m = new Map();
    for (const it of items) {
      const k = keyFn(it);
      const label = labelFn(it);
      if (!k || !label) continue;
      if (!m.has(k)) m.set(k, label);
    }
    return [...m.entries()]
      .map(([key, label]) => ({ key, label }))
      .sort((a, b) => a.label.localeCompare(b.label, "es"));
  }

  function fillSelect(select, options, placeholder) {
    select.innerHTML = "";
    const opt0 = document.createElement("option");
    opt0.value = "";
    opt0.textContent = placeholder;
    select.appendChild(opt0);

    options.forEach(({ key, label }) => {
      const o = document.createElement("option");
      o.value = key;         // key normalizada
      o.textContent = label; // label visible
      select.appendChild(o);
    });
  }

  fillSelect(deptSelect, uniqOptions(stores, s => s._depKey, s => s.department), "Departamento");
  fillSelect(citySelect, uniqOptions(stores, s => s._cityKey, s => s.city), "Ciudad");
  fillSelect(typeSelect, uniqOptions(stores, s => s._typeKey, s => s.type), "Tipo");

  deptSelect.addEventListener("change", () => {
    const depKey = deptSelect.value;
    const subset = depKey ? stores.filter(s => s._depKey === depKey) : stores;
    fillSelect(citySelect, uniqOptions(subset, s => s._cityKey, s => s.city), "Ciudad");
    render();
  });

  citySelect.addEventListener("change", () => render());
  typeSelect.addEventListener("change", () => render());

  searchInput.addEventListener("input", () => {
    clearTimeout(searchInput._t);
    searchInput._t = setTimeout(render, 150);
  });

  // ---------------------------
  // FILTER
  // ---------------------------
  function getFiltered() {
    const depKey = deptSelect.value;
    const cityKey = citySelect.value;
    const typeKey = typeSelect.value;
    const q = normSearch(searchInput.value);

    return stores.filter((s) => {
      if (depKey && s._depKey !== depKey) return false;
      if (cityKey && s._cityKey !== cityKey) return false;
      if (typeKey && s._typeKey !== typeKey) return false;

      if (q) {
        const blob = normSearch([s.id, s.name, s.address, s.neighborhood, s.city, s.department, s.type].join(" "));
        if (!blob.includes(q)) return false;
      }
      return true;
    });
  }

  // ---------------------------
  // RENDER (BLINDADO)
  // ---------------------------
  function render(listOverride) {
    const list = Array.isArray(listOverride) ? listOverride : getFiltered();

    results.innerHTML = "";
    markersLayer.clearLayers();

    const top = list.slice(0, 80);

    const cleanDigits = (v) => cleanStr(v).replace(/\D/g, "");
    const cleanTel = (v) => cleanStr(v).replace(/\s+/g, "");

    top.forEach((s) => {
      const card = document.createElement("div");
      card.className = "sl-card";

      const whatsapp = cleanDigits(s.whatsapp);
      const phone = cleanTel(s.phone);
      const hours = cleanStr(s.hours);

      card.innerHTML = `
        <h4>${escapeHtml(s.name || s.id)}</h4>
        <div class="sl-meta">
          <span class="sl-pill">${escapeHtml(s.type || "")}</span>
          ${s.neighborhood ? `<span class="sl-pill">${escapeHtml(s.neighborhood)}</span>` : ""}
          <div style="margin-top:6px">${[s.address, s.city, s.department].filter(Boolean).map(escapeHtml).join(", ")}</div>
          ${hours ? `<div style="margin-top:6px"><b>Horario:</b> ${escapeHtml(hours)}</div>` : ""}
          ${Number.isFinite(s._km) ? `<div style="margin-top:6px"><b>Distancia:</b> ${s._km.toFixed(1)} km</div>` : ""}
        </div>
        <div class="sl-actions">
          <a href="https://www.google.com/maps?q=${encodeURIComponent(`${s.lat},${s.lng}`)}" target="_blank" rel="noopener">Cómo llegar</a>
          ${whatsapp ? `<a href="https://wa.me/${whatsapp}" target="_blank" rel="noopener">WhatsApp</a>` : ""}
          ${phone ? `<a href="tel:${phone}" rel="noopener">Llamar</a>` : ""}
        </div>
      `;
      results.appendChild(card);

      const m = L.marker([+s.lat, +s.lng]).addTo(markersLayer);
      m.bindPopup(`<b>${escapeHtml(s.name || s.id)}</b><br>${escapeHtml(s.address || "")}`);

      card.addEventListener("mouseenter", () => m.openPopup());
      card.addEventListener("click", () => {
        map.setView([+s.lat, +s.lng], 15);
        m.openPopup();
      });
    });

    if (top.length) {
      map.fitBounds(L.latLngBounds(top.map(s => [+s.lat, +s.lng])), { padding: [30, 30] });
    }
  }

  // ---------------------------
  // CERCA DE MÍ (GEO + RANKING)
  // ---------------------------
  function haversineKm(a, b) {
    const R = 6371;
    const dLat = (b.lat - a.lat) * Math.PI / 180;
    const dLng = (b.lng - a.lng) * Math.PI / 180;
    const lat1 = a.lat * Math.PI / 180;
    const lat2 = b.lat * Math.PI / 180;

    const x =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;

    return 2 * R * Math.asin(Math.sqrt(x));
  }

  nearBtn?.addEventListener("click", () => {
    if (!navigator.geolocation) {
      alert("Tu navegador no soporta geolocalización.");
      return;
    }

    nearBtn.disabled = true;
    const originalText = nearBtn.textContent;
    nearBtn.textContent = "Buscando...";

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const me = { lat: pos.coords.latitude, lng: pos.coords.longitude };

        // Respeta los filtros actuales (si quieres que ignore filtros, te lo cambio)
        const base = getFiltered();

        const ranked = base
          .map((s) => ({
            ...s,
            _km: haversineKm(me, { lat: +s.lat, lng: +s.lng }),
          }))
          .sort((a, b) => a._km - b._km);

        render(ranked);

        // Centra en mi ubicación (opcional)
        map.setView([me.lat, me.lng], 12);

        nearBtn.disabled = false;
        nearBtn.textContent = originalText;
      },
      (err) => {
        nearBtn.disabled = false;
        nearBtn.textContent = originalText;

        // Mensaje claro por el caso más común: permisos
        if (err && err.code === 1) {
          alert("Permiso denegado. Activa la ubicación para usar 'Cerca de mí'.");
        } else {
          alert("No se pudo obtener tu ubicación. Revisa permisos del navegador.");
        }
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  });

  // Init
  render();
})();